import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class AdvancedLink extends Inline {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('href', value.url || value.host);
    // Por retrocompatibilidad es posible que llegue configuración de links con el campo follow en lugar de nofollow
    if ('follow' in value) {
      value.nofollow = value.follow;
      delete value.follow;
    }
    if (value.nofollow) {
      node.setAttribute('rel', 'nofollow');
    }
    node.setAttribute('target', value.target ? '_blank' : '_self');
    node.dataset.value = JSON.stringify(value);
    return node;
  }

  static formats(domNode) {
    return JSON.parse(domNode.dataset.value);
  }

  format(name, value) {
    if (name !== this.statics.blotName || !value) {
      super.format(name, value);
    } else {
      this.domNode.setAttribute('href', value.url || value.host);
      this.domNode.dataset.value = JSON.stringify(value);
    }
  }
}

AdvancedLink.tagName = 'a';
AdvancedLink.blotName = 'advanced-link';
AdvancedLink.className = 'ql-advanced-link';

export default AdvancedLink;
